var CityDataTestidEnum = /* @__PURE__ */ ((CityDataTestidEnum2) => {
  CityDataTestidEnum2["CITY_ASSISTED_PURCHASE_BUTTON"] = "city--assisted-purchase-button";
  CityDataTestidEnum2["CITY_BRANCH_SCHEDULE_BUTTON"] = "city--branch-schedule-button";
  CityDataTestidEnum2["CITY_MEDPREV_ONLINE_SCHEDULE_BUTTON"] = "city--medprev-online-schedule-button";
  CityDataTestidEnum2["CITY_NOTIFY_ME_BUTTON"] = "city--notify-me-button";
  CityDataTestidEnum2["CITY_TELEMEDICINE_SCHEDULE_BUTTON"] = "city--telemedicine-schedule-button";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_DEFAULT"] = "city--search-section-default";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_CITY"] = "city--search-section-city";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_BRANCH"] = "city--search-section-branch";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_BRANCH_TITLE"] = "city--search-section-branch-title";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_TITLE"] = "city--search-section-title";
  CityDataTestidEnum2["CITY_SEARCH_SECTION_SUBTITLE"] = "city--search-section-subtitle";
  CityDataTestidEnum2["CITY_CTA_BOX_BUTTONS"] = "city--cta-box-buttons";
  CityDataTestidEnum2["CITY_LOCATION_BAR"] = "city--location-bar";
  CityDataTestidEnum2["CITY_MOST_SEARCHED_SECTION"] = "city--most-searched-section";
  CityDataTestidEnum2["CITY_MOST_SEARCHED_SECTION_BRANCH"] = "city--most-searched-section-branch";
  CityDataTestidEnum2["CITY_MOST_SEARCHED_SECTION_CARD"] = "city--most-searched-section-card";
  CityDataTestidEnum2["CITY_MOST_SEARCHED_SECTION_FILTER"] = "city--most-searched-section-filter";
  CityDataTestidEnum2["CITY_FILTER_IMAGE_EXAM"] = "city---filter-image-exam";
  CityDataTestidEnum2["CITY_FILTER_ONLINE_CONSULTATION"] = "city--home-filter-online-consultation";
  CityDataTestidEnum2["CITY_FILTER_PRESENTIAL_CONSULTATION"] = "city--home-filter-presential-consultation";
  CityDataTestidEnum2["CITY_FILTER_LABORATORIAL_EXAM"] = "city--filter-laboratorial-exam";
  CityDataTestidEnum2["CITY_BANNER_SECTION"] = "city--banner-section";
  CityDataTestidEnum2["CITY_BANNER_SECTION_CAROUSEL"] = "city--banner-section-carousel";
  CityDataTestidEnum2["CITY_BANNER_SHEET_OPEN"] = "city--banner-sheet-open";
  CityDataTestidEnum2["CITY_BANNER_IMAGE"] = "city--banner-image";
  CityDataTestidEnum2["CITY_BENEFITS_SECTION"] = "city--benefits-section";
  CityDataTestidEnum2["CITY_TESTIMONIAL_SECTION"] = "city--testimonial-section";
  CityDataTestidEnum2["CITY_TESTIMONIAL_SECTION_CARD"] = "city--testimonial-section-card";
  CityDataTestidEnum2["CITY_TESTIMONIAL_SECTION_MESSAGE"] = "city--testimonial-section-message";
  CityDataTestidEnum2["CITY_BRAND_SECTION"] = "city--brand-section";
  CityDataTestidEnum2["CITY_BRAND_SECTION_ICON"] = "city--brand-section-icon";
  CityDataTestidEnum2["CITY_FACE_TO_FACE_SERVICE_SECTION"] = "city--face-to-face-section";
  CityDataTestidEnum2["CITY_NOTIFY_ME_FORM"] = "city--notify-me-form";
  CityDataTestidEnum2["CITY_NOTIFY_ME_FORM_INPUT_NAME"] = "city--notify-me-form-input-name";
  CityDataTestidEnum2["CITY_NOTIFY_ME_FORM_INPUT_EMAIL"] = "city--notify-me-form-input-email";
  CityDataTestidEnum2["CITY_NOTIFY_ME_FORM_BUTTON"] = "city--notify-me-form-button";
  CityDataTestidEnum2["CITY_BRANCHES_NEAR_YOU_SECTION"] = "city--branches-near-you-section";
  CityDataTestidEnum2["CITY_BRANCHES_NEAR_YOU_SECTION_INPUT"] = "city--branches-near-you-section-input";
  CityDataTestidEnum2["CITY_HEALTH_CARE_SECTION"] = "city--health-care-section";
  CityDataTestidEnum2["CITY_BRANCH_LIST_SECTION"] = "city--branch-list-section";
  CityDataTestidEnum2["CITY_BRANCH_LIST_TITLE"] = "city--branch-list-title";
  CityDataTestidEnum2["CITY_BRANCH_LIST_AVATAR"] = "city--branch-list-avatar";
  CityDataTestidEnum2["CITY_BRANCH_LIST_ADDRESS"] = "city--branch-list-address";
  CityDataTestidEnum2["CITY_BRANCH_LIST_WHATSAPP_BUTTON"] = "city--branch-list-whatsapp-button";
  CityDataTestidEnum2["CITY_BRANCH_LIST_VIEW_BRANCH_BUTTON"] = "city--branch-list-view-branch-button";
  CityDataTestidEnum2["CITY_BRANCH_LIST_SEE_ON_MAP_BUTTON"] = "city--branch-list-see-on-map-button";
  CityDataTestidEnum2["CITY_BRANCH_LIST_TOGGLE_BUTTON"] = "city--branch-list-toggle-butotn";
  CityDataTestidEnum2["CITY_BRANCH_LIST_AVATAR_DEFAULT"] = "city--branch-list-avatar-default";
  CityDataTestidEnum2["CITY_BRANCH_LIST_ITEM"] = "city--branch-list-item";
  CityDataTestidEnum2["CITY_BRANCH_PROFILE_SECTION"] = "city--branch-profile-section";
  CityDataTestidEnum2["CITY_DOWNLOAD_APP_SECTION"] = "city--download-app-section";
  CityDataTestidEnum2["CITY_DOWNLOAD_APP_SECTION_BUTTON"] = "city--download-app-section-button";
  CityDataTestidEnum2["CITY_DOWNLOAD_APP_SECTION_QR_CODE"] = "city--download-app-section-qr-code";
  return CityDataTestidEnum2;
})(CityDataTestidEnum || {});
export {
  CityDataTestidEnum
};
